import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import SocialLinks from './SocialLinks'
import './Navbar.css'

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  const { isAuthenticated, user, logout, isAdmin } = useAuth()
  const navigate = useNavigate()

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)
  const closeMenu = () => setIsMenuOpen(false)

  const handleLogout = () => {
    logout()
    navigate('/')
    setIsUserMenuOpen(false)
    closeMenu()
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo-container" onClick={closeMenu}>
          <img src="/logo.png" alt="CarWrap Artist" className="navbar-logo-image" />
        </Link>

        <button
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Menu aan/uit"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Single slide-in panel on mobile — wraps both nav links and auth */}
        <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-menu">
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
            </li>
            <li className="nav-item">
              <Link to="/projects" className="nav-link" onClick={closeMenu}>Projecten</Link>
            </li>
            {/* <li className="nav-item">
              <Link to="/shop" className="nav-link" onClick={closeMenu}>Winkel</Link>
            </li> */}
            <li className="nav-item">
              <Link to="/team" className="nav-link" onClick={closeMenu}>Team</Link>
            </li>
            <li className="nav-item">
              <Link to="/vacatures" className="nav-link" onClick={closeMenu}>Vacatures</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact</Link>
            </li>
          </ul>

          <div className="navbar-auth">
            {isAuthenticated ? (
              <div className="user-menu">
                <button
                  className="user-menu-btn"
                  onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                >
                  👤 {user?.username || 'Gebruiker'}
                </button>
                {isUserMenuOpen && (
                  <div className="user-dropdown">
                    <Link to="/dashboard" className="dropdown-item" onClick={() => {
                      setIsUserMenuOpen(false)
                      closeMenu()
                    }}>
                      📊 Dashboard
                    </Link>
                    {isAdmin && (
                      <Link to="/admin" className="dropdown-item" onClick={() => {
                        setIsUserMenuOpen(false)
                        closeMenu()
                      }}>
                        ⚙️ Beheerderspaneel
                      </Link>
                    )}
                    <button className="dropdown-item logout-item" onClick={handleLogout}>
                      🚪 Uitloggen
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="auth-buttons">
                <Link to="/login" className="auth-btn login-btn" onClick={closeMenu}>
                  Inloggen
                </Link>
                <Link to="/signup" className="auth-btn signup-btn" onClick={closeMenu}>
                  Registreren
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className="navbar-social">
          <SocialLinks />
        </div>
      </div>
    </nav>
  )
}

export default Navbar
